<template lang="pug">
	header(:class="(dev) ? 'dev' : ''")
		div.sideTop(ref="sidetop")
			div(class="menuToggle", ref="menuToggle")
				img(src="/static/recursos/menu.svg", style="margin:5px;margin-left:10px;height: 40px;", @click="toggleMenu")
			div(class="topLogo", ref="capaLogo")
				img(v-if="!dev", src="/static/recursos/logo_sip_white.svg", style="height:30px;", alt="")
				img(v-else, src="/static/recursos/logo_sip_white_devel.svg", style="margin-left:15px;height:30px;", alt="")
				div(style="font-size:0.9em;color:white;vertical-align:bottom;")
					b v.{{version}}
		div.globalMenu
			//
				.nombre(ref="capanombre")
					| {{titulo}}
					span.fa.fa-caret-right.ml-2
			.menu(ref="capamenu", :style="estilo")
				.item(v-for="item in menu", @click="clickItem(item)", :class="(item.activo) ? 'active' : ''")
					.span(:class="item.icono", style="font-size:1.2em;")
					div {{item.nombre}}
			.iconos(ref="capaiconos", :class="(notificacionesNuevas.length > 0) ? 'activo' : ''")
				div(style="position:relative", @click="verNotificaciones = !verNotificaciones")
					audio(style="display:none;" src="/src/modulos/core/static/notificacion.mp3", ref="notificacion")
					span.fa(style="cursor: pointer;", :class="(notificaciones.length > 0) ? 'fa-bell' : 'fa-bell-slash'")
					.badge.badge-danger.contadorNotis(v-if="notificacionesNuevas.length > 0") {{notificacionesNuevas.length}}
					ListadoNotificaciones.listadoNotificaciones(v-if="verNotificaciones", @cerrar="verNotificaciones = false")

		Update(:version="version", :actual="SIP_VERSION", :pospuesto="updatePospuesto" v-if="SIP_VERSION !== version && version !== null", @posponer="posponerUpdate()")
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ListadoNotificaciones from '../notificaciones/listado'
import Update from '../update/update'
import axios from 'axios'
export default {
	components: {
		ListadoNotificaciones,
		Update
	},
	data: () => {
		return {
			version: null,
			intervalo: null,
			estilo: {},
			dev: false,
			verNotificaciones: false,
			polling: false,
			ajax: null,
			nextUpdateCheck: new Date().getTime() - 2000,
			updatePospuesto: false
		}
	},
	created () {
		if (window.webpackHotUpdate) {
			this.dev = true
		}
		this.pollNotificaciones()
	},
	mounted () {
		window.addEventListener('resize', this.calculaAncho)
		this.calculaAncho()
		this.intervalo = window.setInterval(() => {
			this.getVersion()
		}, 60000)
		this.getVersion()
	},
	beforeDestroy () {
		window.removeEventListener('resize', this.calculaAncho)
		this.ajax.abort()
		this.polling = false
		window.clearInterval(this.intervalo)
	},
	beforeRouteUpdate (to, from, next) {
		console.log(to)
		next()
	},
	watch: {
		titulo () {
			window.setTimeout(() => {
				this.calculaAncho()
			}, 300)
		},
		menu () {
			window.setTimeout(() => {
				this.calculaAncho()
			}, 300)
		},
		iconos () {
			window.setTimeout(() => {
				this.calculaAncho()
			}, 300)
		},
		notificacionesNuevas (newVal, oldVal) {
			if (newVal.length > oldVal.length) {
				this.$refs.notificacion.play()
			}
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			titulo: 'top/titulo',
			menu: 'top/menu',
			iconos: 'top/iconos',
			notificaciones: 'notificaciones/listado',
			notificacionesNuevas: 'notificaciones/nuevas'
		})
	},
	methods: {
		...mapActions({
			getNotificaciones: 'notificaciones/get'
		}),
		...mapMutations({
			addNotificaciones: 'notificaciones/ADD'
		}),
		posponerUpdate () {
			this.nextUpdateCheck = new Date().getTime() + 300000
			window.setTimeout(() => {
				this.version = null
				this.updatePospuesto = true
			}, 1000)
		},
		pollNotificaciones () {
			if (!this.usuario || !this.usuario.ID || this.polling) {
				console.log('No hay usuario')
				return
			}
			this.polling = true
			const LastID = this.notificaciones.reduce((acc, noti) => {
				if (acc === 0 || acc < noti.NotificacionID) {
					acc = noti.NotificacionID
				}
				return acc
			}, 0)
			this.ajax = new XMLHttpRequest()
			this.ajax.open('GET', 'src/modulos/core/php/api/notificaciones/polling_notificaciones.php?LastID=' + LastID, true)
			this.ajax.onreadystatechange = () => {
				if (this.ajax.readyState === 4) {
					if (this.ajax.status === 200) {
						this.polling = false
						if (!this.usuario) {
							return
						}
						const res = JSON.parse(this.ajax.responseText)
						res.forEach(noti => {
							this.addNotificaciones(noti)
						})
						this.pollNotificaciones()
					} else {
						window.setTimeout(() => {
							this.polling = false
							this.pollNotificaciones()
						}, 30000)
					}
				}
			}
			this.ajax.send()
		},
		calculaAncho () {
			const ventana = window.outerWidth
			const capaSide = this.$refs.sidetop.offsetWidth
			// const nombre = this.$refs.capanombre.offsetWidth
			const iconos = this.$refs.capaiconos.offsetWidth
			const ancho = ventana - iconos - capaSide
			this.estilo = {
				width: ancho + 'px'
			}
			this.$forceUpdate()
		},
		toggleMenu () {
			this.$emit('togglemenu')
		},
		getVersion () {
			if (new Date().getTime() < this.nextUpdateCheck) {
				return
			}
			axios.get('core/php/api/version.php')
				.then(res => {
					this.version = res.data
				})
				.catch(e => {
					console.error(e)
				})
		},
		clickItem (item) {
			if (item.callback) {
				item.callback(item)
			}
		}
	}
}
</script>

<style scoped>

.develDiv {
	position: fixed;
	top: 10px;
	left: 210px;
	font-weight: bold;
}
header {
	position: relative;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: flex-start;
}
.sideTop {
	flex-basis: 200px;
	flex-grow: 0;
	flex-shrink: 0;
	width: 200px;
}
.menuToggle {
	position: relative;
	display: none;
}

.topLogo {
	position: relative;
	display: table-cell;
	text-align:center;
	vertical-align: middle;
	height: 50px;
	width:199px;
	/* background-color: #f9f9f9; */
	/* background-image: url("/static/recursos/logo.png"); */
}
.globalMenu {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: stretch;
	color: white;
	width: 100%;
	max-width: 100%;
	height: 100%;
	flex-grow: 1;
}
.globalMenu > div {
	padding: 5px;
	align-self: center;
}
.nombre {
	flex-shrink: 0;
	text-align: left;
	font-size: 1.6em;
}

.menu {
	display: flex;
	/* flex-grow: auto;
	flex-shrink: 1; */
	flex-direction: row;
	flex-wrap: nowrap;
	text-align: left;
	/* align-self: stretch !important; */
	/*background-color: rgba(255,255,255,0.5);*/
	overflow: hidden;
	overflow-x: auto;
	padding: 0 !important;
	margin: 0 !important;
}

.item {
	position: relative;
	display: inline-block;
	text-align: center;
	min-width:50px;
	max-width:100px;
	padding-top: 6px;
	padding-left: 10px;
	padding-right: 10px;
	cursor: pointer;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;

}
.item:hover {
	background-color: rgba(255,255,255,0.3);
}

.item.active {
	background-color: white !important;
	color: #39404B;
}

.iconos {
	text-align: right;
	font-size: 1.5em;
	flex-basis: 50px;
	text-align: center;
	margin-right:10px;
	padding-left: 0;
	color: rgba(255, 255, 255, 0.5);
}

.iconos.activo {
	color: white;
}

.iconos > div {
	cursor: pointer;
}

.iconos > div:hover {
	background-color: rgba(255, 255, 255, 0.3);
}

.iconos > div > span {
	padding: 5px;
}

.contadorNotis {
	position: absolute;
	display: block;
	font-size: 0.5em;
	right: 5px;
	bottom: 2px;
}

@media (max-width:1200px) {
	.sideTop {
		position: relative;
		flex-shrink: 1;
	}

	.menuToggle {
		position: relative;
		display: table-cell;
		width: 50px;
		height: 50px;
		vertical-align: middle;
		text-align: center;
		cursor: pointer;
	}
	.topLogo {
		text-align:center;
		height: 50px;
		width: 80px;
		/* background-image: url("/static/recursos/logo.png"); */
	}
}

.listadoNotificaciones {
	position: absolute;
	display: block;
	top: 35px;
	right: 2px;
	width: 350px;
	font-size: 12px;
}

.nuevaVersion {
	position: fixed;
	display: block;
	top: -150px;
	background-color: #f9f9f9;
	border: 1px solid #e0e0e0;
	color: #444444;
	border-radius: 3px;
	width: 300px;
	padding: 5px;
	left: 50%;
	margin-left: -150px;
	box-shadow: 0 0 10px rgba(0,0,0,0.1);
	transition: transform 600ms ease-in-out;
}

.nuevaVersion.show {
	transform: translateY(200px);
}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/topbar/topbar.vue